import {
  CONSENT_UPDATE,
} from './actions';

export default function(state = {}, action) {
  switch (action.type) {
    case CONSENT_UPDATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/consent/index.js